import styled from "styled-components";

export const SliderStyled = styled.input`
    width: 100%;
    &::-webkit-slider-thumb {
        cursor: pointer; /* Cursor on hover */
    }
`;
